import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DeleteForever } from '@material-ui/icons';

export default class LedmoduleItem extends React.Component {

	render() {

		const ledmodule = this.props.ledmodule;

		const infoUrl = `/ledmodules/${ledmodule.id}/info`;

		var creationDate = new Date(/*ledmodule.creationDate*/);
		ledmodule.creationDate = creationDate;

		return (
			<tr>
				<td>
					<Link to={infoUrl} className="a-cloud-list">
						{ledmodule.name}
					</Link>
				</td>
				<td>
					{ledmodule.description}
				</td>
				<td>
					{moment(ledmodule.lastModified).format('DD/MM/YYYY HH:mm')}
				</td>
				<td>
					{ledmodule.isPublished ? 'Yes' : 'No'}
				</td>
				<td style={{ padding: "0.25rem" }}>
					<DeleteForever className="delete-recent-ledmodule" style={{ cursor: "pointer", color: "black", fontSize: "1.25rem" }} onClick={(e) => this.props.deleteLedmodule(ledmodule)} />
				</td>
			</tr>
		);
	}
}